import { ReactSVG } from "react-svg";

export const DrawerIcon = () => {
  return <ReactSVG src={"/fri-media/logo-fri-text2.svg"}></ReactSVG>;
};
